// extracted by mini-css-extract-plugin
export default {"wrap":"Jp-z","fullWidth":"Kp-z","items":"Lp-z","featureCss":"Mp-z","disabled":"Np-z","imgCss":"Op-z"};